import React, { Fragment, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Box,
  Heading,
  Text,
  useColorModeValue,
  Image,
  Link,
  HStack,
  SimpleGrid,
  GridItem,
  VStack,
  Flex,
  keyframes,
  Avatar,
} from "@chakra-ui/react";
import dayjs from "dayjs";
export const BlogAuthor = (props) => {
  return (
    <Fragment>
      <HStack
        ml={2}
        marginTop="0"
        spacing="2"
        display="flex"
        alignItems="center"
      >
        <Avatar
          // borderRadius="full"
          boxSize="30px"
          src={props.avatar}
          name={`${props.name}`}
        />
        <Box>
          <Text as="h6" fontSize="xs">
            {props.name}
          </Text>
          {/* <Text fontSize='xx-small'>—</Text> */}
          <Text fontSize="xs">{dayjs(props?.date).format("DD MMMM YYYY")}</Text>
        </Box>
      </HStack>
    </Fragment>
  );
};

const SubjectLayout = ({ subjects, user, onOpen }) => {
  console.log("🚀 ~ SubjectLayout ~ subjects:", subjects)
  const history = useHistory();
  const color = useColorModeValue("gray.700", "gray.200");

  const handleSubjectRoute = (subjectId, contentFor, teacherId) => {
    if (contentFor === "VIP") {
      if (user?.member === "VIP" || user?._id === teacherId) {
        history.push(`/subject/${subjectId}`);
      } else {
        onOpen();
      }
    } else {
      history.push(`/subject/${subjectId}`);
    }
  };

  const visibleSubjects = Array.isArray(subjects)
    ? subjects.filter((s) => s.status === "public").slice(0, 8)
    : [];

  return (
    <Fragment>
      <SimpleGrid
        columns={{
          base: 1,
          sm: 2,
          md: 3,
          lg: 4,
        }}
        spacingX={{
          base: 5,
          lg: 10,
        }}
        w={"full"}
        minH={"60vh"}
      >
        {visibleSubjects.length === 0 ? (
          <GridItem colSpan={4} textAlign="center" mt={10}>
            <Text fontSize="2xl" color="gray.500">
              ไม่มีคอร์สเรียน
            </Text>
          </GridItem>
        ) : (
          visibleSubjects.map((subject) => (
            <GridItem key={subject?._id} w="100%" sm={"12"} mt={5}>
              <Link
                onClick={() =>
                  handleSubjectRoute(
                    subject?._id,
                    subject.contentfor,
                    subject.teacher?._id
                  )
                }
              >
                <Box
                  borderRadius="lg"
                  borderWidth="2px"
                  boxShadow="2xl"
                  overflow="hidden"
                  w="100%"
                  maxW="350px"
                  mx="auto"
                  _hover={{ boxShadow: "xl", transform: "scale(1.02)" }}
                  transition="all 0.2s"
                  bg="white"
                  display="flex"
                  flexDirection="column"
                  h="100%" // ensure height context for flex grow
                >
                  {/* Top image with overlay text */}
                  <Box position="relative" h="180px" w="full">
                    <Image
                      src={
                        subject?.photo ||
                        "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
                      }
                      objectFit="cover"
                      w="100%"
                      h="100%"
                    />
                    <Box
                      position="absolute"
                      top="0"
                      left="0"
                      w="100%"
                      h="100%"
                      bg="rgba(0, 0, 0, 0.4)"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Text
                        fontSize="lg"
                        fontWeight="bold"
                        color="white"
                        textAlign="center"
                        px={2}
                        noOfLines={2}
                      >
                        {subject?.name}
                      </Text>
                    </Box>
                  </Box>

                  {/* Bottom description section */}
                  <Box
                    p={4}
                    display="flex"
                    flexDirection="column"
                    flex="1"
                    justifyContent="space-between"
                    minH="100px"
                  >
                    <Text
                      textAlign="center"
                      fontSize="sm"
                      color="gray.700"
                      noOfLines={2}
                    >
                      {subject?.description || ""}
                    </Text>
                    <Text
                      alignSelf="flex-end"
                      fontSize="xs"
                      color="gray.500"
                      mt="auto"
                      fontStyle="italic"
                      noOfLines={1}
                    >
                      {`${subject?.teacher?.firstname || ""} ${
                        subject?.teacher?.lastname || ""
                      }`}
                    </Text>
                  </Box>
                </Box>
              </Link>
            </GridItem>
          ))
        )}
      </SimpleGrid>
    </Fragment>
  );
};

SubjectLayout.propTypes = {
  subject: PropTypes.shape(),
  user: PropTypes.shape(),
  id: PropTypes.string,
  onOpen: PropTypes.func,
};

SubjectLayout.defaultProps = {
  subject: {},
  user: {},
  id: "",
  onOpen: () => {},
};
export default SubjectLayout;
